<template>
	<div class="setting-container">
		<el-card class="box-card" shadow="never">
			<div class="security-section">
				<div class="info-item">
					<span class="label">{{ $t('账号名称') }}</span>
					<span class="content">{{userInfo.username}}</span>
				</div>

				<div class="info-item">
					<span class="label">{{ $t('登录密码') }}</span>
					<span class="content">********</span>
					<el-button type="text" class="modify-btn">{{ $t('修改') }}</el-button>
				</div>

				<div class="info-item">
					<span class="label">{{ $t('开启第二次验证') }}</span>
					<el-button size="mini" round class="action-btn">{{ $t('开启') }}</el-button>
				</div>
			</div>
			<el-divider></el-divider>
			<el-form :model="form" label-width="100px" class="setting-form">
				<el-form-item :label="$t('工作语言')">
					<el-select v-model="form.language" :placeholder="$t('请选择')" style="width: 350px">
						<el-option label="日語" value="ja"></el-option>
						<el-option label="中文" value="zh"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('所在时区')">
					<el-select v-model="form.timezone" :placeholder="$t('请选择')" style="width: 350px">
						<el-option label="亞洲/上海(GMT+08:00)" value="Asia/Shanghai"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('信息提示音')">
					<div class="sound-config">
						<el-select v-model="form.sound" :placeholder="$t('请选择')" style="width: 300px">
							<el-option label="提示音1" value="sound1"></el-option>
						</el-select>
						<div class="interval-input">
							<span> {{ $t('提示间隔') }}</span>
							<el-input v-model="form.interval" size="small"
								style="width: 80px; margin: 0 10px;"></el-input>
							<span>s {{ $t('一次') }}</span>
							<!-- <i class="el-icon-info tips-icon"></i> -->
						</div>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" class="save-btn" @click="submitForm">保存信息</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	data() {
		return {
			form: {
				language: 'ja',
				timezone: 'Asia/Shanghai',
				sound: 'sound1',
				interval: '10'
			}
		};
	},
	computed: {
		// 使用对象展开运算符将 Vuex 状态混入外部计算属性中
		...mapState(['userInfo']),
	},
	methods: {
		submitForm() {
			this.$message.success('保存成功');
		}
	}
};
</script>

<style lang="scss" scoped>
.setting-container {
	min-width: 800px;

	.security-section {
		.info-item {
			display: flex;
			align-items: center;
			margin-bottom: 25px;
			font-size: 14px;

			.label {
				width: 100px;
				color: #606266;
			}

			.content {
				margin-right: 40px;
				color: #303133;
			}

			.action-btn {
				border-color: #dcdfe6;
				color: #606266;
				padding: 6px 15px;
				margin-left: 15px;
			}

			.tips {
				color: #909399;
				font-size: 13px;
			}

			.modify-btn {
				padding: 0;
			}

		}
	}

	.setting-form {
		margin-top: 30px;

		.sound-config {
			border: 1px solid #ebeef5;
			padding: 15px;
			border-radius: 4px;
			width: 350px;

			.interval-input {
				margin-top: 15px;
				display: flex;
				align-items: center;
				color: #606266;
				font-size: 13px;
			}
		}

		.save-btn {
			width: 200px;
			background-color: #3b59fe;
			border-color: #3b59fe;
		}
	}

	.tips-icon {
		margin-left: 5px;
		color: #909399;
		cursor: pointer;
	}
}
</style>